/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Why the linear ratchet solve stopped
 */
export enum LinearSolveStop {
    NOTHING_TO_GROW = 'nothing-to-grow',
    FILLED_TIER = 'filled-tier',
    LANDED = 'landed',
    BLOCKED = 'blocked',
    STARVED = 'starved',
    OVERRAN = 'overran',
    RESTART_LIMIT = 'restart-limit',
}
